import {
  IStore,
  IStoreChangeData,
  IStoreRenewalResponseData,
  IStoreResponseData,
} from '@dataTypes/userInfo';
import { instance } from './index';
import { IDashBoardRenewalRequest } from '@dataTypes/dashBoardSummary';
import { saveAs } from 'file-saver';
import { PAYMETHOD } from '@dataTypes/totalSalesTypes';

export const getDashboardSummaryWithMaster = async () => {
  const response = await instance.get(`/master/dashboard/summary`);
  return response.data;
};

export const getDashboardSummaryWithUser = async (storeId: number | undefined) => {
  if (storeId === undefined) {
    return;
  }
  const response = await instance.get(`/user/dashboard/summary/store/${storeId}`);
  return response.data;
};

export const getUserMainData = async () => {
  const response = await instance.get(`/user/init/main`);
  return response.data;
};

export const getMasterMainData = async () => {
  const response = await instance.get(`/master/init/main`);
  return response.data;
};

export const changeStore = async (storeId: number): Promise<IStoreChangeData> => {
  const response = await instance.get(`/user/switch/store/${storeId}`);
  return response.data;
};

export const changeStoreByMaster = async (storeId: number): Promise<IStoreChangeData> => {
  const response = await instance.get(`/master/switch/store/${storeId}`);
  return response.data;
};

export const renewStoreListsMaster = async (): Promise<IStoreRenewalResponseData> => {
  const response = await instance.get(`/master/renew/storelists`);
  return response.data;
};

export const getManagerBranches = async (): Promise<IStoreResponseData> => {
  const response = await instance.get(`/user/store/manager/branches`);
  return response.data;
};

export const getDashboardMonthSalesList = async (storeId: number | undefined, date: string) => {
  if (storeId === undefined) {
    return;
  }
  const response = await instance.get(`/user/monthly/${storeId}/${date}`);
  return response.data;
};

export const renewalDashboardByMaster = async (data: IDashBoardRenewalRequest) => {
  const response = await instance.put(`/master/renewal/dashboard`, data);
  return response.data;
};

export const searchStoreListsByMaster = async (searchName: string) => {
  const response = await instance.get(`/master/search/storelists/${searchName}`);
  return response.data;
};

export const updateStoreMileageDisplay = async (
  storeId: number,
  mileageVisible: boolean,
): Promise<void> => {
  await instance.put(`/master/store/${storeId}/mileage-display`, { mileageVisible });
};

export const downloadMonthSales = async (storeId: number, yyyymm: string) => {
  const res = await instance.get<BlobPart>(`/user/monthly/${storeId}/${yyyymm}/download`, {
    responseType: 'blob',
  });

  // 파일명(Content-Disposition) 있으면 사용
  const cd = res.headers?.['content-disposition'] ?? '';
  const filename =
    decodeURIComponent(cd.match(/filename\*=UTF-8''([^;]+)/)?.[1] || '') ||
    cd.match(/filename="?([^"]+)"?/)?.[1] ||
    `month_sales_${storeId}_${yyyymm}.xlsx`;

  const blob = new Blob([res.data], {
    type:
      res.headers?.['content-type'] ||
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });

  saveAs(blob, filename);

  return true;
};

/**
 * @description 통합매출 엑셀 다운로드
 * @param storeId: 지점 번호
 * @param startDate: 시작 날짜
 * @param endDate: 종료 날짜
 * @param catId: 단말기 번호
 * @param method: 결제 방법
 */
export const downloadPerMachineSummarySale = async (
  storeId: number | undefined,
  startDate: string,
  endDate: string,
  catId: string,
  method: PAYMETHOD,
) => {
  if (storeId === undefined) {
    return;
  }

  const params = new URLSearchParams();
  params.set('storeId', String(storeId));
  params.set('deviceId', catId);
  params.set('paymentMethod', method);
  params.set('startDate', startDate);
  params.set('endDate', endDate);

  const res = await instance.get<BlobPart>(`/user/device-sales/download?${params.toString()}`, {
    responseType: 'blob',
  });
  // 파일명(Content-Disposition) 있으면 사용
  const cd = res.headers?.['content-disposition'] ?? '';
  const filename =
    decodeURIComponent(cd.match(/filename\*=UTF-8''([^;]+)/)?.[1] || '') ||
    cd.match(/filename="?([^"]+)"?/)?.[1] ||
    `month_sales_${storeId}_${startDate}~${endDate}.xlsx`;

  const blob = new Blob([res.data], {
    type:
      res.headers?.['content-type'] ||
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });

  saveAs(blob, filename);

  return true;
};
